<template>
    <div>
  
      <!-- <v-row class="mb-16">
        <v-col cols="12" md="12"> -->
      <!-- <v-card-title class="text-h4 font-weight-bold mb-4">
          Financeiro 
      </v-card-title> -->
      <!-- 
        </v-col>
        <v-col cols="12">
          <template> -->
      <v-card color="" elevation="0" class="">
        <v-divider></v-divider>
        <template>
          <v-tabs color="primary" v-model="tabs" class="" height="80" background-color="#f4f4f4">
            <div class="d-flex align-center px-4">
            <v-icon color="primary" size="">mdi-finance</v-icon>
            <h5 class="font-weight-bold headline ml-2">
              {{ $t("financial.title") }}
            </h5>
          </div>
            <v-tab class="ml-4">{{ $t("financial.billing") }}</v-tab>
            <v-tab>  {{ $t("financial.incomeAndDoc") }}</v-tab>
            <v-tab>  {{ $t("financial.config") }}</v-tab>
          </v-tabs>
        </template>
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <BillingTable/>
          </v-tab-item>
          <v-tab-item>
            <FinancialTable/>
          </v-tab-item>
          <v-tab-item>
            <FinancialStores/>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
      <!-- </template>
        </v-col>
      </v-row>-->
    </div>
  </template>
  
  <script>
  // import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";

import FinancialTable from '@/components/financial/FinancialTable.vue';
import BillingTable from '@/components/financial/BillingTable.vue';
import FinancialStores from '@/components/financial/FinancialStores.vue'
  
  export default {
    name: "SalesTable",
    components: {
      FinancialTable,
      BillingTable,
      FinancialStores
    },
    data() {
      return {
        tabs: 0,
       
      };
    },
    mounted() {
      this.loadTabs()
    },
    watch: {
      '$route.params.tab'(){
        this.loadTabs()
      },
      'tabs'(nV){
        let query = []
        for(let key in this.$route.query){
          // if(nV != 0 && key == 'q')
          query.push(`${key}=${this.$route.query[key]}`)
        }
        const qstring = query.length ? `?${query.join('&')}` : ''
        
        if(nV == 0 && this.$route.path != '/financial/invoicing')
        this.$router.replace(`/financial/invoicing${qstring}`)
        if(nV == 1 && this.$route.path != '/sales/documents')
          this.$router.replace(`/financial/documents${qstring}`)
         
           
      }
    },
    methods: {
      loadTabs() {
        if (!this.$route.params.tab) {
          this.tabs = 0
        }
        else {
          if (this.$route.params.tab == 'invoicing') {
            this.tabs = 0
          }
          if (this.$route.params.tab == 'documents') {
            this.tabs = 1
          }
       
        }
      }
    },
  }
  </script>
  
  <style lang="scss" scoped>
  
  </style>